<p-fieldset
  class="learning-modules-container__mainContent__fieldSet"
  [ngClass]="containerConstants[type].className"
>
  <p-header class="learning-modules-container__mainContent__fieldSet--header"
    ><mat-icon>{{ containerConstants[type].icon }}</mat-icon
    >{{ containerConstants[type].title }}</p-header
  >
  <ng-content></ng-content>
</p-fieldset>
